const mxValidator = (value) => {
  if (!value) return "validate.mx_empty";
  const [host] = value.split(/\s+/);
  if (!host || !/^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/.test(host))
    return "validate.mx_host_failed";
  return true;
};

export { mxValidator };
